<template>
  <div class="modal-overlay">
    <div class="modal-card">
      <div class="modal-header">
        <h3 class="font-weight-bold">
          {{ $t("login.classic.header") }}
        </h3>
        <span
          class="close-btn"
          @click="$emit('close')"
        >✕</span>
      </div>

      <div class="modal-body">
        <img
          src="@/assets/logo/logo.png"
          class="logo mb-8"
        >

        <h2 class="title-text">
          Fit Daily Monitoring
        </h2>

        <form @submit.prevent="login">
          <div class="form-group mb-4">
            <label class="form-text">
              {{ $t("login.form.username") }}
            </label>
            <div class="input-group mb-6">
              <div class="input-group-prepend">
                <div class="input-group-text bg-white text-info">
                  <i
                    class="fa fa-user"
                    aria-hidden="true"
                  />
                </div>
              </div>
              <input
                v-model.trim="$v.username.$model"
                type="text"
                class="form-control form-control-lg"
                :class="{ 'is-invalid': $v.username.$error }"
                :placeholder="$t('login.form.username')"
              >
            </div>
            <div
              v-if="!$v.username.required && $v.username.$error"
              class="text-danger"
            >
              <small>
                {{ $t("login.form-error.username-required") }}
              </small>
            </div>
          </div>

          <div class="form-group mb-5">
            <label class="form-text">
              {{ $t("login.form.password") }}
            </label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text bg-white text-info">
                  <i
                    class="fa fa-lock"
                    aria-hidden="true"
                  />
                </div>
              </div>
              <input
                v-model.trim="$v.password.$model"
                :type="passwordType"
                class="form-control form-control-lg"
                :class="{ 'is-invalid': $v.password.$error }"
                :placeholder="$t('login.form.password')"
              >
              <a
                class="password-reveal"
                @click="revealPassword"
              >
                <i
                  class="fa fa-eye"
                  aria-hidden="true"
                />
              </a>
            </div>
            <div
              v-if="!$v.password.required && $v.password.$error"
              class="text-danger"
            >
              <small>
                {{ $t("login.form-error.password-required") }}
              </small>
            </div>
          </div>

          <button
            type="submit"
            class="btn btn-info btn-block mt-4 py-3"
          >
            <small
              v-if="!loading"
              class="form-text"
            >
              {{ $t("login.button.login") }}
            </small>
            <div
              v-else
              class="text-center"
            >
              <div class="spinner-border spinner-border-sm">
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </div>
          </button>
        </form>
      </div>
    </div>
    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalWarning
      v-show="modal.warning"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import Api from '@/utils/Api'
import { isToday } from 'date-fns'
import {
  required,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import ModalWarning from '@/components/modal/ModalWarning'

export default {
  components: {
    ModalUnsuccessful,
    ModalWarning
  },

  data () {
    return {
      username: '',
      password: '',
      passwordType: 'password',
      loading: false,
      modal: {
        unsuccessful: false,
        warning: false,
        textModal: ''
      },
      errorCode: ''
    }
  },

  created () {
    window.addEventListener('beforeunload', function (event) {
      localStorage.removeItem('HRISAccount')
    })
  },

  methods: {
    async login () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        const form = {
          username: this.username,
          password: this.password,
          language: this.$i18n.locale.toUpperCase()
        }
        const data = await Api.postLogin(form)

        if (data !== undefined) {
          if (data.data.status === 200 || data.data.status === 2001) {
            if (data.data.data.isRequiredMfa) {
              const { userId, userEmail } = data.data.data

              const partialEmail = userEmail.replace(
                /^(.{3})(.*?)(.{2})@(.{3})(.*?)(\.\w+)$/,
                (_, a, b, c, d, e, f) =>
                  a +
                  '*'.repeat(b.length) +
                  c +
                  '@' +
                  d +
                  '*'.repeat(e.length) +
                  f
              )

              localStorage.setItem('mfaUserId', userId)
              localStorage.setItem('mfaUserEmail', partialEmail)
              // this.nextPageMfa()
              this.loading = false
              this.$emit('require-mfa')
            } else if (!data.data.data.isRequiredMfa) {
              localStorage.data = JSON.stringify(data.data.data)
              localStorage.token = data.data.data.token
              localStorage.refreshToken = data.data.data.refreshToken
              localStorage.login = true
              try {
                const { data: profile } = await Api.users.me()
                localStorage.profile = JSON.stringify(profile)
                await this.setDefaultRoute()
                this.nextPage(profile)
                window.scrollTo(0, 0)
                this.loading = false
              } catch ({ response }) {
                this.loading = false
                localStorage.clear()
                this.modal.textModal = this.$t('login.net-error')
                this.showModal('unsuccessful')
              }
            }
          } else {
            this.loading = false
            this.errorCode = data.data.status
            if (this.$i18n.locale === 'en') {
              this.modal.textModal = data.data.message.messageEng
            } else {
              this.modal.textModal = data.data.message.messageIdn
            }
            if (data.data.status === 202) {
              localStorage.HRISAccount = JSON.stringify(data.data.data)
              this.showModal('warning')
            } else {
              this.showModal('unsuccessful')
            }
          }
        } else {
          this.loading = false
          this.modal.textModal = this.$t('login.net-error')
          this.showModal('unsuccessful')
        }
      }
    },
    warningRegister () {
      if (this.$i18n.locale === 'en') {
        this.modal.textModal = 'Still under construction, thank you.'
      } else if (this.$i18n.locale === 'id') {
        this.modal.textModal = 'Masih dalam proses pengerjaan, terima kasih.'
      }
      this.showModal('warning')
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      if (this.errorCode === 202) {
        this.$router.push({
          name: 'personaldata'
        })
      }
    },
    setDefaultRoute () {
      const profile = JSON.parse(localStorage.getItem('profile'))
      let routing = profile.role.permissions
      routing = routing.sort((a, b) => (a.level > b.level) ? 1 : ((b.level > a.level) ? -1 : 0))
      localStorage.setItem('defaultRoute', JSON.stringify(routing[0]))
    },
    nextPage ({ lastSubmissionDate }) {
      const defaultRouting = JSON.parse(localStorage.getItem('defaultRoute'))
      if ((defaultRouting.category === 'my_dhm' || defaultRouting.category === 'all_dhm') && defaultRouting.permissions.includes('add')) {
        if (lastSubmissionDate && isToday(new Date(lastSubmissionDate))) {
          this.$router.push({
            name: defaultRouting.category
          })
        } else {
          this.$router.push({
            name: 'success-login'
          })
        }
      } else {
        this.$router.replace({
          name: defaultRouting.category
        })
      }
    },
    nextPageMfa () {
      this.$router.push({
        name: 'verify-login'
      })
    },
    revealPassword () {
      this.passwordType = this.passwordType === 'password'
        ? 'text'
        : 'password'
    }
  },

  validations: {
    username: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
    password: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(255)
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-card {
  background: white;
  width: 420px;
  max-width: 90vw;
  border-radius: 16px;
  padding: 32px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-weight: bold;
}

.logo {
  width: 64px;
  margin: 16px 0;
  display: block;
}

.title-text {
  margin-bottom: 24px;
  font-weight: bold;
  text-align: left;
  font-size: 28px;
}

.form-text {
  font-weight: 600;
  font-size: 14px;
}

.close-btn {
  cursor: pointer;
  font-size: 16px;
}

.form-control-lg {
  font-size: 14px;
  padding: 10px 12px;
}

.btn-info {
  padding: 10px;
}

/* MOBILE */

@media (max-height: 700px) {
  .modal-card {
    max-height: 90vh;
    overflow-y: auto;
  }
}
</style>
